module.exports = __webpack_public_path__ + "static/media/illustration.e2a7d1d2.svg";